import React from "react";

export const decimalReportFormatter = (cell, row, text) => {
  if (!cell) return cell;
  if (isNaN(Number(cell))) return cell;

  const value = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cell);

  if (text) return value;
  return (
    <span
      className="font-bold"
      style={{
        color: cell > 0 ? "rgb(28, 209, 94)" : "rgb(213, 54, 54)",
      }}
    >
      {value}
    </span>
  );
};

export const decimalInvertedReportFormatter = (cell, row, text) => {
  if (!cell) return cell;
  if (isNaN(cell)) return cell;

  const value = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cell);

  if (text) return value;
  return (
    <span
      className="font-bold"
      style={{
        color: cell < 0 ? "rgb(28, 209, 94)" : "rgb(213, 54, 54)",
      }}
    >
      {value}
    </span>
  );
};

export const percentageReportFormatter = (cell, row, text) => {
  if (!cell) return cell;
  if (Number.isNaN(cell)) return cell;

  if (text) return `${cell}%`;
  return (
    <span
      className="font-bold"
      style={{
        color: cell > 0 ? "rgb(28, 209, 94)" : "rgb(213, 54, 54)",
      }}
    >
      {cell}%
    </span>
  );
};
